module.exports = __webpack_public_path__ + "img/change-password.57cd1225.png";